import { Color } from '@billy/design-system'
import styled from '@emotion/styled'

export const SavingContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  background-color: ${Color.White};
`
